var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"loaderRef",staticClass:"infinite-loader"},[_c('WindowEventListener',{attrs:{"event":"scroll"},on:{"trigger":_vm.checkEndReached}}),(_vm.isLoading)?_c('s-loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }